import React from "react";
import styled from "styled-components";
import Modal from "./Modal";
import { C, F, CARD_RING, ring, Button } from "../styles";
import { IconCheck, IconSheet, IconStar, IconStopwatch } from "./Icons";

const Card = styled.div`
  width: 100%;
  max-width: 500px;
  max-height: 92vh;
  overflow: auto;
  border-radius: 20px;
  background: ${C.blue};
  box-shadow: ${ring(1.5, C.yellow)}, 0 30px 60px -20px rgba(0, 0, 0, 0.6);
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
  align-items: center;
`;

const Title = styled.span`
  font: 700 26px/1.15 ${F.title};
  letter-spacing: -0.03em;
`;

const Sub = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.85);
`;

const Items = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: left;
`;

const Item = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 12px 14px;
  border-radius: 14px;
  background: ${C.navy};
  box-shadow: ${CARD_RING};
`;

const IconBox = styled.span`
  flex: none;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ItemText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  b {
    font: 700 14px/1.25 ${F.title};
  }
  span {
    font-size: 13px;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.72);
  }
`;

const Later = styled.button`
  font: 600 14px/1 ${F.title};
  background: none;
  border: none;
  color: ${C.white};
  text-decoration: underline;
  cursor: pointer;
  padding: 6px;
`;

const ITEMS = [
  [IconSheet, "20 questões", "Inéditas, no formato do Enem, com uma alternativa certa por questão."],
  [IconStopwatch, "Sem cronômetro", "Faça no seu ritmo. Suas respostas ficam salvas e dá pra sair e voltar."],
  [IconStar, "Uma tentativa", "Depois de enviar, não dá pra refazer. Sua nota é o número de acertos."],
  [IconCheck, "Gabarito na hora", "Assim que você envia, com a resolução de cada questão."],
];

export default function ConfirmModal({ area, busy, onConfirm, onClose }) {
  return (
    <Modal onClose={onClose} label="Confirmação">
      <Card>
        <Title>Bora começar?</Title>
        <Sub>
          Simulado de {area.name} · disponível até {area.closeLabel}
        </Sub>
        <Items>
          {ITEMS.map(([Icon, title, text]) => (
            <Item key={title}>
              <IconBox>
                <Icon color={C.yellow} size={20} />
              </IconBox>
              <ItemText>
                <b>{title}</b>
                <span>{text}</span>
              </ItemText>
            </Item>
          ))}
        </Items>
        <Button variant="orange" block size={16} pad="16px" disabled={busy} onClick={onConfirm}>
          SIM, COMEÇAR AGORA
        </Button>
        <Later type="button" onClick={onClose}>
          Ainda não
        </Later>
      </Card>
    </Modal>
  );
}
